import {createContext} from "react";

export const CartConfigContext = createContext({});

